import type { SxProps, Theme } from '@mui/material/styles';

export const styles = {
    textFrequentlyUsedTitle: {
        textAlign: 'left',
    },
    // MUI v4's IconButton padding (8px since v5)
    searchButton: {
        p: '12px',
    },
} satisfies Record<string, SxProps<Theme>>;
